if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if(this.submitButton){
         this.submitButtonText = this.submitButton.querySelector('span');
         if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Retrieve the form element itself
        const formElement = this.form;
        
        // Get the checkbox element
        const checkbox = document.getElementById('subscribeCheckbox');
        const axChargeCode = document.querySelector('._ax_charge_code')?.value || '';
        
        if (axChargeCode === 'WEB_BUNDLE') {
            // Get values from the input elements
            const bundleProperties = {
              _bundle_title: document.querySelector('._bundle_title')?.value || '',
              _bundle_slug: document.querySelector('._bundle_slug')?.value || '',
              _bundle_image: document.querySelector('._bundle_image')?.value || '',
              _bundle_price: document.querySelector('._bundle_price')?.value || '',
              _axChargeCode: "exclude_OD",
              _bundle_compare_price: document.querySelector('._bundle_compare_price')?.value || '',
              _bundle_final_price: document.querySelector('._bundle_final_price')?.value || '',
              _bundle_final_compare_price: document.querySelector('._bundle_final_compare_price')?.value || '',
              _bundle_item_count: document.querySelector('._bundle_item_count')?.value || '',

            };

            // Append each property to the formData object
            appendPropertiesToFormData(bundleProperties);
          
        }
        
        if (checkbox) {
            if (checkbox.checked) {
                handleCheckedSubscription();
            } else {
                handleUncheckedSubscription();
            }
        } else {
          handleUncheckedSubscription();
        }
        
        /**
         * Handles the logic when the subscription checkbox is checked.
         */
        function handleCheckedSubscription() {
            // Get values from the input fields
            const applyDiscount = document.querySelector('.apply_discount')?.value ||  false;
          
            const subscribeFrequency = document.querySelector('.js-subscribe-frequency')?.value || null;
            const subscribeUnit = document.querySelector('.js-subscribe-unit')?.value || null;
            const subscribeTitle = document.querySelector('.js-subscribe-title')?.value || null;
            const subscribeDiscountPct = document.querySelector('.js-subscribe-discount-pct')?.value || null;
            const subscribeOriginalPrice = document.querySelector('.js-subscribe-original-price')?.value || null;
            const subscribeUrl = document.querySelector('.js-subscribe-url')?.value || null;
        
            // Check for missing values
            if (!subscribeFrequency || !subscribeUnit || !subscribeDiscountPct || !subscribeOriginalPrice || !subscribeUrl) {
                console.warn('Some subscription input fields are missing.');
                return; // Exit the function if required fields are missing
            }
        
            // Create properties object
            const subscriptionProperties = {
                _ax_charge_code: "WEB_SUBSCRIBE",
                _shipping_interval_frequency: Number(subscribeFrequency),
                _shipping_interval_unit_type: subscribeUnit,
                _subscription_variant_title: subscribeTitle,
                _subscription_pct_off: Number(subscribeDiscountPct),
                _subscription_original_price: Number(subscribeOriginalPrice),
                _subscription_url: subscribeUrl,
                _cart_calculation: Number(subscribeDiscountPct),
                _apply_discount: applyDiscount
            };
        
            // Append properties to formData
            appendPropertiesToFormData(subscriptionProperties);
        }
        
        /**
         * Handles the logic when the subscription checkbox is unchecked.
         */
        function handleUncheckedSubscription() {
            // Get values from the input fields
            const subscribeDiscountPct = formElement.querySelector('.js-subscribe-discount-pct')?.value || null;
            const applyDiscount = formElement.querySelector('.apply_discount')?.value ||  false;
            const otmquantityInput = document.getElementById('otmquantity')?.value ||  false;
            let uncheckedSubscriptionProperties = {};
            if(otmquantityInput != false)
            {
              // Create properties object
              uncheckedSubscriptionProperties = {
                  _cart_calculation: subscribeDiscountPct,
                  _tube_product: true
              };             
            }
            else
            {
               // Create properties object
              uncheckedSubscriptionProperties = {
                  _cart_calculation: subscribeDiscountPct,
                  _apply_discount: applyDiscount
              }; 
            }
            
            // Append properties to formData
            appendPropertiesToFormData(uncheckedSubscriptionProperties);
        }
        
        /**
         * Appends properties to the global formData object.
         * @param {Object} properties - Key-value pairs to append to formData.
         */
        function appendPropertiesToFormData(properties) {
            for (const [key, value] of Object.entries(properties)) {
                formData.append(`properties[${key}]`, value);
            }
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed',() => {
                  const freeProductElement = document.querySelector('.freeproduct');
                  if (freeProductElement) 
                  {
                    this.addFreeGiftIfEligible(response);
                  }
                  else
                  {
                    this.cart.renderContents(response);
                  }
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } 
            else 
            {
              const freeProductElement = document.querySelector('.freeproduct');
              if (freeProductElement) 
              {
                this.addFreeGiftIfEligible(response);
              }
              else
              {
                this.cart.renderContents(response);
              }
            }//else closed

            var json_data = {
              value: response.final_line_price / 100.0,
              quantity: response.quantity,
              product_id: response.id,
              product_name: response.title,
              product_type: response.product_type,
              product_vendor: response.vendor,
              variant_id: response.variant_id,
              variant_name: response.variant_title
            };
            this.spotifyATCEvent(json_data);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
      
      //this is for free gift
      // addFreeGiftIfEligible(old_response) {
      //   console.log("addFreeGiftIfEligible call...");
      //   let gift_with_purchse = document.querySelector('#gift_with_purchse');
      //   const cartElement = document.querySelector('cart-drawer');
      //   const free_id = document.querySelector('.freeproduct').value;
        
      //   const formData2 = new FormData(gift_with_purchse);
      //   formData2.append(
      //     'sections',
      //     cartElement.getSectionsToRender().map((section) => section.id)
      //   );
      //   formData2.append('sections_url', window.location.pathname);
      //   cartElement.setActiveElement(document.activeElement);

      //   fetch('/cart.js')
      //   .then(response => response.json())
      //   .then(cart => {
      //     const cartTotal = cart.total_price;
      //     let freekey = '';

      //     // Check if the gift is already in the cart
      //     const giftInCart = cart.items.filter(item => item.id == free_id);
      //     if(giftInCart.length>0)
      //     {
      //       freekey = giftInCart[0].id;
      //     }
          
      //     if (freekey=='' && cartTotal > 0) {

      //       const config2 = fetchConfig('javascript');
      //       config2.headers['X-Requested-With'] = 'XMLHttpRequest';
      //       delete config2.headers['Content-Type'];
            
      //       config2.body = formData2;
      //       fetch(`${routes.cart_add_url}`, config2)
      //       .then((response) => response.json())
      //       .then((response) => {
      //         cartElement.renderContents(response);
      //       })
      //       .catch((error) => {
      //         console.error('Error adding to cart:', error);
      //       });
      //     }//if closed
      //     else{
      //       console.log("Free gift already exist..");
      //       cartElement.renderContents(old_response);
      //     }//else closed
          
      //   })
      //   .catch(error => {
      //    console.error('Error fetching cart:', error);
      //   });
          
      // }//function closed

        addFreeGiftIfEligible(old_response) {
          console.log("addFreeGiftIfEligible call...");
          
          // Get cart element (same as old code)
          const cartElement = document.querySelector('cart-drawer');
          if (!cartElement) {
            console.error('Cart element not found');
            return;
          }

          // Check if feature is enabled
          if (!window.giftWithPurchaseConfig || !window.giftWithPurchaseConfig.enabled) {
            console.log('Gift with purchase is disabled');
            cartElement.renderContents(old_response);
            return;
          }

          fetch('/cart.js')
            .then(response => response.json())
            .then(async cart => {  // ✅ Added async here
              const cartTotal = cart.total_price;
              
              // ✅ Added await here
              const qualifiesForGift = await this.checkCartQualification(cart.items);
              
              if (!qualifiesForGift) {
                console.log('Cart does not contain qualifying collections or products');
                cartElement.renderContents(old_response);
                return;
              }
              
              // Get eligible gifts based on threshold
              const giftsToAdd = this.determineEligibleGifts(cartTotal, cart.items);
              
              if (giftsToAdd.length > 0) {
                this.addGiftsSequentially(giftsToAdd, cartElement, old_response);
              } else {
                console.log("No eligible free gifts");
                cartElement.renderContents(old_response);
              }
            })
            .catch(error => {
              console.error('Error fetching cart:', error);
              cartElement.renderContents(old_response);
            });
        }

        checkCartQualification(cartItems) {  // ✅ Removed async (not needed)
          const config = window.giftWithPurchaseConfig;
          
          // Handle both array and comma-separated string
          let qualifyingProductIds = config.qualifyingProductIds || [];
          
          // If it's a string, convert to array
          if (typeof config.qualifyingProductIdsString === 'string' && config.qualifyingProductIdsString !== '') {
            qualifyingProductIds = config.qualifyingProductIdsString.split(',').map(id => parseInt(id.trim()));
          }
          
          console.log('=== Gift Qualification Check ===');
          console.log('Qualifying Product IDs:', qualifyingProductIds);
          console.log('Total qualifying products:', qualifyingProductIds.length);
          
          // If no restrictions set, all carts qualify
          if (qualifyingProductIds.length === 0) {
            console.log('✅ No restrictions - all carts qualify');
            return true;
          }
          
          // Check each cart item
          for (let item of cartItems) {
            const itemProductId = parseInt(item.product_id);
            console.log(`\nChecking: ${item.product_title} (ID: ${itemProductId})`);
            
            // Check if item's product_id is in the qualifying list
            if (qualifyingProductIds.includes(itemProductId)) {
              console.log(`  ✅ MATCH! Product ID ${itemProductId} qualifies`);
              return true;
            }
          }
          
          console.log('\n❌ No qualifying products found in cart');
          return false;
        }

        determineEligibleGifts(cartTotal, cartItems) {
          const config = window.giftWithPurchaseConfig;
          const eligibleGifts = [];
          const cartItemIds = cartItems.map(item => item.variant_id);
          
          console.log('\n=== Determining Eligible Gifts ===');
          console.log('Cart Total:', cartTotal);
          
          // Check each tier from highest to lowest
          for (let tierConfig of config.tiers.slice().reverse()) {
            if (!tierConfig.enabled) {
              console.log(`Tier ${tierConfig.tier}: Disabled`);
              continue;
            }
            
            if (!tierConfig.variantId) {
              console.log(`Tier ${tierConfig.tier}: No variant ID`);
              continue;
            }
            
            // Check if gift already in cart
            if (cartItemIds.includes(parseInt(tierConfig.variantId))) {
              console.log(`Tier ${tierConfig.tier}: Already in cart`);
              continue;
            }
            
            // Check if threshold met
            if (cartTotal >= tierConfig.threshold) {
              console.log(`Tier ${tierConfig.tier}: ✅ Eligible (threshold: ${tierConfig.threshold})`);
              eligibleGifts.push({
                tier: tierConfig.tier,
                variantId: tierConfig.variantId,
                threshold: tierConfig.threshold
              });
            } else {
              console.log(`Tier ${tierConfig.tier}: ❌ Below threshold (needs: ${tierConfig.threshold})`);
            }
          }
          
          return eligibleGifts;
        }

        addGiftsSequentially(gifts, cartElement, old_response) {
          const addNextGift = (index) => {
            if (index >= gifts.length) {
              // All gifts added, refresh cart with NEW response
              console.log('All gifts added, refreshing cart with new data...');
              
              // Create a dummy form update to get fresh sections
              const formData = new FormData();
              formData.append(
                'sections',
                cartElement.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              
              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
              config.body = formData;
              
              // Fetch the updated cart with all sections
              return fetch(`${routes.cart_update_url}`, config)
                .then(response => response.json())
                .then((freshResponse) => {
                  console.log('✅ Cart refreshed with all gifts');
                  cartElement.renderContents(freshResponse);
                })
                .catch(error => {
                  console.error('Error refreshing cart:', error);
                  // Fallback to old response if something goes wrong
                  cartElement.renderContents(old_response);
                });
            }
            
            const gift = gifts[index];
            console.log(`Adding gift tier ${gift.tier}...`);
            
            // Create FormData exactly like old code
            const formData = new FormData();
            formData.append('id', gift.variantId);
            formData.append('quantity', 1);
            // formData.append('properties[_gift_tier]', gift.tier);
            formData.append('properties[_free_gift_product]', 'true');
            
            // Add sections (from old code)
            formData.append(
              'sections',
              cartElement.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            cartElement.setActiveElement(document.activeElement);
            
            // Use fetchConfig exactly like old code
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;
            
            // Fetch exactly like old code
            return fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                console.log(`✅ Added gift tier ${gift.tier}`);
                // Continue to next gift
                return addNextGift(index + 1);
              })
              .catch((error) => {
                console.error(`Error adding gift tier ${gift.tier}:`, error);
                // Continue even if error
                return addNextGift(index + 1);
              });
          };
          
          // Start adding gifts
          addNextGift(0);
        }

      //Spotify script
      spotifyATCEvent(data){
        (function(w, d){
          
          var id='spdt-capture', n='script';
          if (!d.getElementById(id)) {
            w.spdt =
              w.spdt ||
              function() {
                (w.spdt.q = w.spdt.q || []).push(arguments);
              };
            var e = d.createElement(n); e.id = id; e.async=1;
            e.src = 'https://pixel.byspotify.com/ping.min.js';
            var s = d.getElementsByTagName(n)[0];
            s.parentNode.insertBefore(e, s);
          }
          
          w.spdt('conf', { key: '9ec78a80b0e4427187d34686a07270aa' });
          w.spdt('addtocart', {
            value: data.value,  // Dynamically populate from session data
            currency: 'USD',  
            quantity: data.qty,  // Dynamically populate from session data
            product_id: data.product_id,  // Dynamically populate from session data
            product_name: data.product_title,  // Dynamically populate from session data
            product_type: data.type,  // Dynamically populate from session data
            product_vendor: data.vendor,  // Dynamically populate from session data
            variant_id: data.variant_id,  // Dynamically populate from session data
            variant_name: data.variant_title,  // Dynamically populate from session data
          });
        })(window, document);
        tatari.track('addtocart', {
          value: data.value,
          currency: 'USD',  
          quantity: data.qty,
          product_id: data.product_id,
          product_name: data.product_title,
          product_type: data.type,
          product_vendor: data.vendor,
          variant_id: data.variant_id,
          variant_name: data.variant_title
        });
      }//fn closed
    });
}//if closed